<template>
  <div
    :class="isOpen ? 'quick-view open' : 'quick-view'"
    @click.self="closePopup()"
  >
    <div class="quick-view-content">
      <div class="bg-white">
        <div class="flex flex-row align-items-center p-2">
          <i @click="isOpen = false" class="fa fa-arrow-left font-22 pointer" />
          <div class="flex flex-1 ml-3">
            <p class="font-16 flex flex-1 bold m-0">{{ detail.code }}</p>
            <p class="sub-text">
              Ngày tạo: {{ $formatDate(detail.startDate) }} |
              {{ $formatTime(detail.startDate) }}
            </p>
          </div>

          <span
            :class="`tag tag-${
              detail.accountantType == 'INCOME' ? 'primary' : 'danger'
            }-outline`"
          >
            {{ detail.accountantType == "INCOME" ? "Phiếu thu" : "Phiếu chi" }}
          </span>
        </div>
      </div>
      <div class="p-2">
        <div class="box">
          <div class="p-2">
            <div class="box">
              <div class="box-item flex flex-row align-items-center">
                <div class="flex flex-2">
                  <label>Yếu tố thu / chi</label>
                  <p class="">{{ detail.elementName || "-" }}</p>
                </div>
                <div class="flex flex-1">
                  <label>Quyển số</label>
                  <p class="">{{ detail.bookNo || "-" }}</p>
                </div>
                <div class="flex flex-1">
                  <label>Số phiếu</label>
                  <p class="">{{ detail.codeNumber || "-" }}</p>
                </div>
              </div>

              <div class="box-item">
                <label>Tổng tiền</label>
                <p class="bold">{{ $formatMoney(detail.totalPayment) }}</p>
              </div>

              <div class="box-item flex flex-row align-items-center">
                <div class="flex flex-1">
                  <label>Người nhận</label>
                  <p>
                    {{ detail.receiverRepresent }}
                  </p>
                </div>

                <div class="flex flex-1">
                  <label>Người nộp</label>
                  <p>
                    {{ detail.transferRepresent }}
                  </p>
                </div>
              </div>

              <div class="box-item flex flex-row align-items-center">
                <div class="flex flex-1">
                  <label>Đối tượng pháp nhân nhận (nợ)</label>
                  <p>
                    {{ detail.receiver }}
                    <span
                      v-if="
                        detail.accountantType == 'EXPENSE' && detail.address
                      "
                    >
                      ({{ detail.address }})
                    </span>
                  </p>
                  <label> {{ detail.receiverCode }}</label>
                </div>

                <div class="flex flex-1">
                  <label>Đối tượng pháp nhân nộp (có)</label>
                  <p>
                    {{ detail.transfer }}
                    <span
                      v-if="detail.accountantType == 'INCOME' && detail.address"
                    >
                      ({{ detail.address }})
                    </span>
                  </p>
                  <label> {{ detail.transferCode }}</label>
                </div>
              </div>

              <div class="box-item" v-if="detail.description">
                <label>Diễn giải</label>
                <p>{{ detail.description }}</p>
              </div>
            </div>
          </div>
          <div class="p-2">
            <h3 class="font-14 bold">Hạch toán</h3>
            <div
              class="box p-2 mb-1 flex flex-row align-items-center"
              v-for="(payment, index) in detail.payments"
              :key="index"
            >
              <div class="flex flex-1 flex-row">
                <div>
                  <label v-if="payment.receiverCode">{{
                    payment.receiverCode
                  }}</label>
                  <p class="bold">{{ payment.receiver || detail.receiver }}</p>
                  {{ payment.debtAcc.detail ? payment.debtAcc.detail.name : '' }}
                  {{ payment.debtAcc.detail ? payment.debtAcc.detail.code : '' }}
                </div>
                <i class="fa fa-arrow-left mr-3 ml-3 font-16" />

                <div>
                  <label v-if="payment.transferCode">{{
                    payment.transferCode
                  }}</label>
                  <p class="bold">{{ payment.transfer || detail.transfer }}</p>
                  {{ payment.availableAcc.detail ? payment.availableAcc.detail.name: '' }}
                  {{ payment.availableAcc.detail ? payment.availableAcc.detail.code: '' }}
                </div>
              </div>
              <p class="bold">{{ $formatMoney(payment.totalPayment) }}</p>
            </div>
          </div>
          <div class="p-2">
            <h3 class="font-14 bold">Thanh toán</h3>

            <div
              class="box p-2 mb-2 flex flex-row align-items-center"
              v-for="(payment, index) in detail.paymentDetails"
              :key="index"
            >
              <div class="flex flex-1">
                <p>{{ payment.isCashPayment ? "Tiền mặt" : "Chuyển khoản" }}</p>
                <p v-if="payment.currencyUnit != $currency" class="sub-text">
                  {{ payment.originalCurrency }} ({{ payment.currencyUnit }} -
                  {{ $formatMoney(payment.exchangePrice) }})
                </p>
              </div>

              <p class="bold">{{ $formatMoney(payment.totalPayment) }}</p>
            </div>
          </div>

          <div class="p-2">
            <h3 class="font-14 bold">Tham khảo</h3>
            <div
              class="box p-2 mb-2 flex flex-row align-items-center"
              v-for="(ref, index) in detail.incomeExpenseRefs"
              :key="index"
            >
              <router-link
                v-if="ref.invoices"
                :to="'/order?code=' + ref.invoices.code"
              >
                Đơn bán #{{ ref.invoices.code }}
              </router-link>
              <router-link
                v-if="ref.purchaseOrders"
                :to="'/stock/purchase/' + ref.purchaseOrders.id"
              >
                Đơn mua #{{ ref.purchaseOrders.code }}
              </router-link>
              <router-link
                v-if="ref.warehouseReceipts"
                :to="'/stock/transfer/' + ref.warehouseReceipts.id"
              >
                Chuyển hàng #{{ ref.warehouseReceipts.code }}
              </router-link>
              <router-link
                v-if="ref.warehouseOutReceipt"
                :to="'/stock/out/' + ref.warehouseOutReceipt.id"
              >
                Xuất hàng #{{ ref.warehouseOutReceipt.code }}
              </router-link>

              <span v-if="ref.employees">
                Nhân viên {{ ref.employees.fullName }}
              </span>
              <span v-if="ref.suppliers">
                Nhà cung cấp {{ ref.suppliers.supplierName }}
              </span>
              <span v-if="ref.customers">
                Khách hàng {{ ref.customers.customerName }}
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "DetailQuickView",
  data: function () {
    return {
      isOpen: false,
      detail: {},
      tabActive: "payment",
    };
  },
  methods: {
    openPopup: function (data) {
      this.isOpen = true;
      this.detail = data;
    },
    closePopup: function () {
      this.isOpen = false;
      // this._cancel();
    },
  },
};
</script>
